<template>
  <!-- 碎片分组 -->
  <div class="debirs_group-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="openDialog(1)"
            >添加碎片分组</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="id" label="分组ID" align="center"> </el-table-column>
        <el-table-column prop="name" label="分组名称" align="center">
        </el-table-column>
        <el-table-column
          prop="action"
          label="操作"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="openDialog(2, row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加弹窗 -->
    <DebrisPartitionDialog
      v-model="dialogInfos"
      :visible="addVisible"
      :type="dialogType"
      @close="addVisible = false"
      @refresh="getData()"
    ></DebrisPartitionDialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import DebrisPartitionDialog from '../../components/debrisActivity/DebrisPartitionDialog.vue'

export default {
  components: {
    DebrisPartitionDialog
  },
  data() {
    return {
      addVisible: false,//添加队伍弹窗显示标志
      loading: false,//加载动画
      dataList: undefined,//数据列表
      dialogType:1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//传给弹窗的数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()//获取数据列表
  },
  methods: {
    getData() {
      this.loading = true
      getApiData('debris_category')
        .then(res => {
          this.dataList = res
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDialog(num, val) {
      //打开添加队伍弹窗
      this.addVisible = true
      if (num === 1) {
        this.dialogType=1
        this.dialogInfos=undefined
      }
      if (num === 2) {
        this.dialogType=2
        this.dialogInfos = JSON.parse(JSON.stringify(val))
      }
    },
  }

}
</script>
<style lang="less" scoped>
</style>